<div class="cd-wrap">

  @if (configError) {
    <div class="cd-state cd-state--error">
      <i class="pi pi-exclamation-triangle" style="font-size: 24px;"></i>
      <span>No se encontró la configuración de este tablero.</span>
    </div>
  } @else if (missingParams.length) {
    <div class="cd-state cd-state--error">
      <i class="pi pi-exclamation-triangle" style="font-size: 24px;"></i>
      <span>
        Parámetro(s) requerido(s) no encontrado(s):
        <strong>{{ missingParams.join(', ') }}</strong>.
        Contacta al administrador.
      </span>
    </div>
  } @else if (!boardConfig) {
    <div class="cd-state">Cargando configuración...</div>
  } @else {

    <!-- ── Tabbar + filtros ── -->
    <div class="cd-tabbar">
      <div class="cd-tabs">
        @for (tab of tabs; track tab.id) {
          <button type="button" class="cd-tab"
                  [class.is-active]="dashTab === tab.id"
                  (click)="onDashTabChange(tab.id)">
            @if (tab.id === 'resumen') {
              <i class="pi pi-map"></i> {{ tab.label }}
            } @else if (tab.id === 'sdv-detail') {
              <i class="pi pi-list"></i> {{ tab.label }}
            } @else if (tab.id === 'analisis') {
              <i class="pi pi-chart-bar"></i> {{ tab.label }}
            } @else {
              {{ tab.label }}
            }
          </button>
        }
      </div>

      <div class="cd-tabbar-filters">

        <!-- Selects dinámicos: un select por cada filtro from_card / static -->
        @for (f of selectableFilters; track f.key) {
          @if ((selectOptions[f.key] || []).length > 0) {
            <mat-select class="cd-rdv-select"
                        panelWidth="auto"
                        panelClass="cd-rdv-select-panel"
                        [class.cd-rdv-select--narrow]="f.key === 'rdv'"
                        [class.cd-rdv-select--mision]="f.key === 'mision'"
                        [value]="filterValues[f.key] || 'all'"
                        (selectionChange)="onSelectFilterChange(f.key, $event.value)">
              <mat-option value="all">{{ f.label || 'Todos' }}</mat-option>
              @for (opt of selectOptions[f.key]; track opt) {
                <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-select>
          }
        }

        <!-- Date range: solo si la pestaña activa lo necesita — trigger simple (span + ícono), sin input visible -->
        @if (activeTabHasDateRange) {
          <button type="button" class="cd-date-trigger" (click)="picker.open()">
            <span>{{ formatDetailDate(detailDateStart) }} – {{ formatDetailDate(detailDateEnd) }}</span>
            <i class="pi pi-calendar"></i>
          </button>

          <!-- Oculto: solo mantiene el modelo/estado que necesita mat-date-range-picker -->
          <mat-form-field appearance="outline" class="cd-daterange-hidden">
            <mat-date-range-input [formGroup]="detailRangeForm" [rangePicker]="picker" aria-label="Rango de fechas">
              <input matStartDate formControlName="start">
              <input matEndDate   formControlName="end">
            </mat-date-range-input>
          </mat-form-field>
          <mat-date-range-picker #picker />
        }

      </div>
    </div>

    <!-- ══════════════════════════════════════════════════════════════════ -->
    <!-- PESTAÑA: OBJETIVOS (tablero SDV — backward compat)               -->
    <!-- ══════════════════════════════════════════════════════════════════ -->
    @if (dashTab === 'general') {
      @if (errorTop) {
        <div class="cd-state cd-state--error">No se pudo cargar el dashboard.</div>
      } @else {

        <app-logo-banner
          class="cd-hero-banner"
          [loading]="loadingBanner"
          [imageUrl]="logoUrl"
          [title]="logoTitle"
          [subtitle]="logoSubtitle"
          [badge]="logoBadge"
          [badgeColor]="'#6366f1'"
          [compliancePercent]="logoCompliancePercent"
          [statusLabel]="logoStatusLabel"
          [statusColor]="logoStatusColor"
          [trend]="logoTrend" />

        <div class="cd-kpi-trend-row">
          @if (isLoading('kpi') || kpiStatusCard) {
            <app-kpi-status-card [config]="kpiStatusCard!" [loading]="isLoading('kpi')"
                                 class="cd-kpi-status-row" />
          }
          @if (isLoading('trend') || trendChartCard) {
            <app-chartjs-card [config]="trendChartCard!" [loading]="isLoading('trend')" />
          }
        </div>

        <div class="cd-stack">
          @if (isLoading('mission') || missionChartCard) {
            <div class="cd-missions-row" style="width: 100%;">
              <app-chartjs-card [config]="missionChartCard!" [loading]="isLoading('mission')" />
            </div>
          }
          @if (!isLoading('mission') && achievementCard) {
            <app-dark-achievement-card [config]="achievementCard" style="display:block;margin-top:12px;" />
          }
          @if (isLoading('mission')) {
            <app-dark-achievement-card [loading]="true" style="display:block;margin-top:12px;" />
          }
          @if (isLoading('rdv') || rdvChartCard) {
            <app-chartjs-card [config]="rdvChartCard!" [loading]="isLoading('rdv')" />
          }
          @if (isLoading('ranking')) {
            <app-chartjs-card [loading]="true" />
          } @else if (rankingChartCard) {
            <app-chartjs-card [config]="rankingChartCard" />
          }
        </div>

      }
    }

    <!-- ══════════════════════════════════════════════════════════════════ -->
    <!-- PESTAÑA: RESUMEN — Mapa de tiendas                                -->
    <!-- ══════════════════════════════════════════════════════════════════ -->
    @if (dashTab === 'resumen') {
      <div class="cd-stack">
        <app-store-heatmap-card
          [config]="storeHeatmapCard ?? undefined"
          [loading]="isLoading('geo-heatmap')"
          [detailsLoading]="storeHeatmapDetailsLoading"
          [active]="dashTab === 'resumen'"
          (storeSelected)="onStoreSelected($event)" />
      </div>
    }

    <!-- ══════════════════════════════════════════════════════════════════ -->
    <!-- PESTAÑA: EJECUCIONES                                              -->
    <!-- ══════════════════════════════════════════════════════════════════ -->
    @if (dashTab === 'sdv-detail') {
      @if (isLoading('executions')) {
        <section class="cd-loading-skeleton">
          <div class="cd-sk-row">
            <div class="cd-sk-card cd-sk-card--chart"></div>
          </div>
        </section>
      } @else if (errorSdvDetail) {
        <div class="cd-state cd-state--error">No se pudo cargar el detalle de ejecuciones.</div>
      } @else if (detailSdvRows.length) {

        @if (detailTotalRows !== null) {
          <div class="cd-detail-total">
            {{ detailTotalRows }} ejecuciones encontradas
            @if (filterValues['mision'] && filterValues['mision'] !== 'all') {
              <span class="cd-detail-total__mission"> · Misión: {{ filterValues['mision'] }}</span>
            }
          </div>
        }

        <div class="cd-detail-cards">
          @for (row of detailSdvRows; track $index) {
            <article class="cd-card-b"
                     [class]="detailStatusClass(row['recognition_task_status'])"
                     (click)="openEventDialog(row)">

              <div class="cd-card-b__img">
                @if (row['original_image_path']) {
                  <img [src]="row['original_image_path']" alt="miniatura" />
                } @else {
                  <span class="cd-thumb--empty"><i class="pi pi-image"></i></span>
                }
                <span class="cd-card-b__img-badge cd-card-b__img-badge--mobile"
                      [class]="detailStatusClass(row['recognition_task_status'])">
                  {{ detailStatusShort(row['recognition_task_status']) }}
                </span>
              </div>

              <div class="cd-card-b__body">
                <span class="cd-card-b__title" [title]="getAsesorTiendaLine(row)">
                  {{ getVendorLine(row) }}<span class="cd-card-b__title-store"> · {{ getTiendaLine(row) }}</span>
                </span>
                <div class="cd-card-b__meta">
                  <span class="cd-card-b__meta-item" [title]="getMisionLine(row)">
                    <i class="pi pi-list-check"></i>
                    {{ getMisionLine(row) }}
                  </span>
                  <span class="cd-card-b__meta-item" [title]="getFechaBonitaLine(row)">
                    <i class="pi pi-calendar"></i>
                    {{ getFechaBonitaLine(row) }}
                  </span>
                </div>
              </div>

              <div class="cd-card-b__aside">
                <span class="cd-status-chip-sm cd-card-b__aside-chip"
                      [class]="detailStatusClass(row['recognition_task_status'])">
                  {{ detailStatusLabel(row['recognition_task_status']) }}
                </span>
              </div>

            </article>
          }
        </div>

        <!-- Paginador -->
        <div class="cd-pager">
          <button class="cd-pager__btn" [disabled]="detailPageOffset === 0" (click)="goToPrevPage()">
            <i class="pi pi-angle-left"></i>
          </button>
          <span class="cd-pager__page is-active">
            @if (detailTotalPages !== null) {
              Página {{ detailCurrentPage }} de {{ detailTotalPages }}
            } @else {
              Página {{ detailCurrentPage }}
            }
          </span>
          <button class="cd-pager__btn" [disabled]="!detailHasNextPage" (click)="goToNextPage()">
            <i class="pi pi-angle-right"></i>
          </button>
        </div>

      } @else {
        <div class="cd-state">Sin datos para el rango de fechas seleccionado.</div>
      }

      <!-- Dialog Template -->
      <ng-template #eventDialogTemplate let-data>
        <mat-dialog-content style="padding: 0; overflow: hidden; height: 100%;">
          @if (data?.uuid) {
            <app-page-visualizer-client
              [eventId]="data.uuid"
              [isDialogMode]="true"
              (closeRequest)="currentDialogRef?.close()"
              style="display: block; width: 100%; height: 100%; overflow: hidden;">
            </app-page-visualizer-client>
          } @else {
            <div class="cd-dialog-body">
              <h3>Detalle del registro</h3>
              <div class="cd-dialog-data">
                @for (k of detailSdvDisplayKeys; track k) {
                  <div><strong>{{ formatColumnName(k) }}:</strong> {{ data?.row?.[k] ?? '—' }}</div>
                }
              </div>
            </div>
          }
        </mat-dialog-content>
      </ng-template>
    }

    <!-- ══════════════════════════════════════════════════════════════════ -->
    <!-- PESTAÑA: ANÁLISIS — sub-navegación interna                        -->
    <!-- ══════════════════════════════════════════════════════════════════ -->
    @if (dashTab === 'analisis') {

      <!-- Sub-nav pills -->
      <div class="cd-subnav">
        <button class="cd-subnav__pill" [class.is-active]="analysisSubTab === 'nevera'"
                (click)="analysisSubTab = 'nevera'">
          <i class="pi pi-box"></i> Nevera
        </button>
        <button class="cd-subnav__pill" [class.is-active]="analysisSubTab === 'contaminacion'"
                (click)="analysisSubTab = 'contaminacion'">
          <i class="pi pi-exclamation-circle"></i> Contaminación
        </button>
        <button class="cd-subnav__pill" [class.is-active]="analysisSubTab === 'galeria'"
                (click)="analysisSubTab = 'galeria'">
          <i class="pi pi-images"></i> Galería
        </button>
        <button class="cd-subnav__pill" [class.is-active]="analysisSubTab === 'heatmap'"
                (click)="analysisSubTab = 'heatmap'">
          <i class="pi pi-chart-scatter"></i> Heatmap
        </button>
        <button class="cd-subnav__pill" [class.is-active]="analysisSubTab === 'objetos'"
                (click)="analysisSubTab = 'objetos'">
          <i class="pi pi-list"></i> Objetos
        </button>
        <button class="cd-subnav__pill" [class.is-active]="analysisSubTab === 'planograma'"
                (click)="analysisSubTab = 'planograma'">
          <i class="pi pi-table"></i> Planograma
        </button>
      </div>

      <!-- Nevera -->
      @if (analysisSubTab === 'nevera') {
        <div class="cd-stack">
          <app-fridge-analysis-card
            [config]="fridgeAnalysisCard"
            [loading]="isLoading('fridge-card')" />
        </div>
      }

      <!-- Contaminación -->
      @if (analysisSubTab === 'contaminacion') {
        <div class="cd-stack">
          <app-contamination-card
            [config]="contaminationCard"
            [loading]="isLoading('contam-card')" />
        </div>
      }

      <!-- Galería -->
      @if (analysisSubTab === 'galeria') {
        <div class="cd-stack">
          <app-bbox-gallery-card
            [config]="bboxGalleryCard!"
            [loading]="isLoading('gallery')" />
        </div>
      }

      <!-- Heatmap de detección -->
      @if (analysisSubTab === 'heatmap') {
        <div class="cd-stack">
          <app-detection-heatmap-card
            [config]="detectionHeatmapCard!"
            [loading]="isLoading('heatmap')" />
        </div>
      }

      <!-- Objetos detectados -->
      @if (analysisSubTab === 'objetos') {
        <div class="cd-stack">
          <app-detected-objects-card
            [config]="detectedObjectsCard!"
            [loading]="isLoading('objects')" />
        </div>
      }

      <!-- Planograma + Cobertura -->
      @if (analysisSubTab === 'planograma') {
        <div class="cd-planogram-row">
          <app-planogram-card
            [config]="planogramCard!"
            [loading]="isLoading('planogram')" />
          <app-area-coverage-card
            [config]="areaCoverageCard!"
            [loading]="isLoading('area-cov')" />
        </div>
      }

    }

  }
</div>
